import {
  GET_ALL_CUSTOM_SKELETONS,
  GET_ALL_CUSTOM_SKELETONS_SUCCESS,
  GET_CUSTOM_SKELETON_BY_ID,
  GET_CUSTOM_SKELETON_BY_ID_SUCCESS,
  GET_SKELETON_DEFAULT_FIELDS,
  GET_SKELETON_DEFAULT_FIELDS_SUCCESS,
  RESET_ACTUAL_CUSTOM_SKELETON,
  POST_CUSTOM_SKELETON,
  PATCH_CUSTOM_SKELETON,
  DELETE_CUSTOM_SKELETON,
} from "./constants"

export function getAllCustomSkeletonsAction(payload) {
  return {
    type: GET_ALL_CUSTOM_SKELETONS,
    payload: payload,
  }
}

export function getAllCustomSkeletonsSuccessAction(payload) {
  return {
    type: GET_ALL_CUSTOM_SKELETONS_SUCCESS,
    payload: payload,
  }
}

export function getCustomSkeletonByIdAction(payload) {
  return {
    type: GET_CUSTOM_SKELETON_BY_ID,
    payload: payload,
  }
}

export function getCustomSkeletonByIdSuccessAction(payload) {
  return {
    type: GET_CUSTOM_SKELETON_BY_ID_SUCCESS,
    payload: payload,
  }
}

export function resetActualCustomSkeletonAction(payload) {
  return {
    type: RESET_ACTUAL_CUSTOM_SKELETON,
    payload: payload,
  }
}

export function getSkeletonDefaultFieldsAction(payload) {
  return {
    type: GET_SKELETON_DEFAULT_FIELDS,
    payload: payload,
  }
}

export function getSkeletonDefaultFieldsSuccessAction(payload) {
  return {
    type: GET_SKELETON_DEFAULT_FIELDS_SUCCESS,
    payload: payload,
  }
}

export function postCustomSkeletonAction(payload) {
  return {
    type: POST_CUSTOM_SKELETON,
    payload: payload,
  }
}

export function patchCustomSkeletonAction(payload) {
  return {
    type: PATCH_CUSTOM_SKELETON,
    payload: payload,
  }
}

export function deleteCustomSkeletonAction(payload) {
  return {
    type: DELETE_CUSTOM_SKELETON,
    payload: payload,
  }
}
